export type Module = {
  number: string
  title: string
  description: string
  duration: string
}

export type Bonus = {
  title: string
  description: string
  value: string
}

export type Testimonial = {
  name: string
  detail: string
  quote: string
  featured?: boolean
}

export type Faq = {
  question: string
  answer: string
}

export const painPoints: string[] = [
  'Te lavas el cabello, sale precioso… y a las tres horas ya es frizz.',
  'Compras producto tras producto y ninguno hace lo que promete.',
  'Tu rizo se define arriba y abajo se abre sin forma.',
  'Terminas recogiéndolo siempre, porque suelto “no te queda bien”.',
  'Nadie te explicó qué porosidad tiene tu cabello ni qué necesita.',
]

export const modules: Module[] = [
  {
    number: '01',
    title: 'Diagnóstico de tu rizo',
    description:
      'Identifica tu patrón, porosidad y densidad en 10 minutos con el test guiado. Todo lo demás depende de este paso.',
    duration: '10 páginas',
  },
  {
    number: '02',
    title: 'Reset capilar',
    description:
      'Cómo eliminar la acumulación de siliconas y sales que aplasta tu rizo, sin resecar el largo.',
    duration: '9 páginas',
  },
  {
    number: '03',
    title: 'La rutina de lavado',
    description:
      'Co-wash, squish to condish y el orden exacto de productos según tu porosidad.',
    duration: '14 páginas',
  },
  {
    number: '04',
    title: 'Definición sin crunch',
    description:
      'Técnicas de aplicación —raking, praying hands, scrunch— y cuánto producto usar de verdad.',
    duration: '13 páginas',
  },
  {
    number: '05',
    title: 'Secado y volumen',
    description:
      'Difusor, plopping y clips de raíz para que el rizo se abra arriba y no se aplaste al día 2.',
    duration: '12 páginas',
  },
  {
    number: '06',
    title: 'Mantenimiento semanal',
    description:
      'Refresh de segundo y tercer día, rutina nocturna y calendario de tratamientos de proteína e hidratación.',
    duration: '12 páginas',
  },
]

export const bonuses: Bonus[] = [
  {
    title: 'Guía de ingredientes',
    description:
      'Lista imprimible de lo que sí y lo que nunca debe llevar tu producto, con marcas de supermercado.',
    value: '$29',
  },
  {
    title: 'Recetas caseras',
    description:
      '12 mascarillas de cocina para hidratación profunda, proteína y brillo, con tiempos exactos.',
    value: '$24',
  },
  {
    title: 'Calendario de 30 días',
    description:
      'Día a día de tu primer mes curly: qué hacer, qué esperar y cómo medir tu progreso.',
    value: '$19',
  },
]

export const testimonials: Testimonial[] = [
  {
    name: 'Mariana R.',
    detail: 'Rizo 3B · Bogotá',
    quote:
      'Llevaba nueve años alisándome porque creía que mi pelo “no servía”. En la tercera semana con el método mi rizo volvió solo. Lo que más me sirvió fue entender mi porosidad: estaba usando productos pesadísimos para un cabello de porosidad baja.',
    featured: true,
  },
  {
    name: 'Tatiana G.',
    detail: 'Ondas 2C · Guadalajara',
    quote:
      'El frizz me duraba desde la hora uno. Cambié el secado al difusor como explica el capítulo 5 y ahora llego al día tres sin volver a mojar el pelo.',
  },
  {
    name: 'Karla M.',
    detail: 'Rizo 4A · Lima',
    quote:
      'Dejé de gastar en productos al azar. Con la guía de ingredientes compro en el supermercado y mi rizo está más hidratado que nunca.',
  },
]

export const faqs: Faq[] = [
  {
    question: '¿Funciona si tengo el cabello con alisado o tinte?',
    answer:
      'Sí. El capítulo 2 incluye una ruta específica para cabello procesado: recuperación progresiva sin cortar todo de una vez, y el calendario de proteína para devolver elasticidad.',
  },
  {
    question: '¿Necesito comprar productos caros?',
    answer:
      'No. La guía de ingredientes está pensada para producto de supermercado. Lo que cambia el resultado es la técnica y el orden, no el precio del frasco.',
  },
  {
    question: '¿Cuándo veo resultados?',
    answer:
      'La mayoría nota más definición desde el primer lavado hecho con la técnica correcta. El cambio estable de textura y volumen aparece entre la semana 3 y la 6.',
  },
  {
    question: '¿Cómo recibo el acceso?',
    answer:
      'Inmediatamente después del pago recibes un correo con tu enlace de descarga. El material es un PDF: lo lees en el celular, la tablet, la computadora o impreso.',
  },
  {
    question: '¿Y si no es para mí?',
    answer:
      'Tienes 30 días para pedir el reembolso completo escribiendo a soporte. Sin formularios ni preguntas.',
  },
]
